import { db } from 'config/firebase';
import {
  Observation,
  ObservationStatus,
  ObservationSubject,
  ReportObservations,
} from 'interfaces/observation';
import { v4 as uuidv4 } from 'uuid';
import firebase from 'firebase/app';
import { fireConverter } from './helpers';

interface CreatePayload {
  reportId: string;
  description: string;
  subject: ObservationSubject;
  source: string;
  status: ObservationStatus;
}

interface UpdatePayload {
  reportId: string;
  observation: Observation;
}

const lookupDocumentRef = async (
  reportId: string
): Promise<firebase.firestore.DocumentSnapshot<ReportObservations>> => {
  const observationsDocRef = await db
    .collection('report-observations')
    .withConverter(fireConverter<ReportObservations>())
    .doc(reportId)
    .get();

  if (observationsDocRef.exists) {
    return observationsDocRef;
  } else {
    throw 'Report not found';
  }
};

export const getObservations = async (
  reportId: string
): Promise<ReportObservations> => {
  return (await lookupDocumentRef(reportId)).data();
};

export const createObservation = async (
  data: CreatePayload
): Promise<Observation> => {
  const observation: Observation = {
    ...data,
    id: uuidv4(),
  };

  return db
    .collection('report-observations')
    .doc(data.reportId)
    .set(
      {
        [data.subject]: firebase.firestore.FieldValue.arrayUnion(observation),
      },
      { merge: true }
    )
    .then((_) => observation);
};

export const updateObservation = async (
  data: UpdatePayload
): Promise<Observation> => {
  const docRef = await lookupDocumentRef(data.reportId);
  const newObservations = docRef
    .data()
    [data.observation.subject].map((observation) =>
      observation.id === data.observation.id ? data.observation : observation
    );

  return db
    .collection('report-observations')
    .doc(data.reportId)
    .set(
      {
        [data.observation.subject]: newObservations,
      },
      { merge: true }
    )
    .then((_) => data.observation);
};
